var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"top","color":"red lighten-2","dark":""}},[_vm._v(" По вашему запросу объявлений не найдено. ")])}
var staticRenderFns = []

export { render, staticRenderFns }